import { Component } from '@angular/core';

@Component({
	selector: 'app-congratulations',
	templateUrl: './congratulations.component.html',
	styleUrls: ['./congratulations.component.scss']
})
export class CongratulationsComponent {}
